#import "~/graphql/fragments/Category.graphql"

query Categories(
    $slug: [String]
    $site: [String] = "nl"
    $section: [String]
    $type: [String]
    $relatedToEntries: [EntryRelationCriteriaInput],
    $orderBy: String
) {
    entries(
        slug: $slug
        site: $site
        section: $section
        type: $type
        relatedToEntries: $relatedToEntries
        orderBy: $orderBy
    ) {
        ... Category
    }
}
